import { authFetch } from './client';

// `owner` (optional) reads the chat history of a project shared by another user.
export const getChatHistory = (projectId, owner) =>
  authFetch(
    `/api/projects/${projectId}/chat-history${owner ? `?owner=${encodeURIComponent(owner)}` : ''}`
  );
export const saveChatHistory = (projectId, messages) =>
  authFetch(`/api/projects/${projectId}/chat-history`, {
    method: 'PUT',
    body: JSON.stringify({ messages }),
  });
export const clearChatHistory = (projectId) =>
  authFetch(`/api/projects/${projectId}/chat-history`, { method: 'DELETE' });

// Per-tile chat history (subagent conversations). Stored as a tileChatHistory map on the project record.
export const getTileChatHistory = (projectId, tileId, owner) =>
  authFetch(
    `/api/projects/${projectId}/tile-chat-history/${tileId}${owner ? `?owner=${encodeURIComponent(owner)}` : ''}`
  );
export const saveTileChatHistory = (projectId, tileId, messages) =>
  authFetch(`/api/projects/${projectId}/tile-chat-history/${tileId}`, {
    method: 'PUT',
    body: JSON.stringify({ messages }),
  });
export const clearTileChatHistory = (projectId, tileId) =>
  authFetch(`/api/projects/${projectId}/tile-chat-history/${tileId}`, { method: 'DELETE' });
